import * as Yup from 'yup';

const ManageMenuValidationSchema = Yup.object().shape({
  price: Yup.number().required('A price is required.').moreThan(0)
});

export default ManageMenuValidationSchema;
